import * as types from "./featuresTypes";

// Checked
export const requestAllFeatures = () => {
  return {
    type: types.REQUEST_ALL_FEATURES
  };
};

export const loadingAllFeatures = () => {
  return {
    type: types.ALL_FEATURES_IS_LOADING
  };
};

// Checked
export const requestAllFeaturesSuccess = data => {
  return {
    type: types.REQUEST_ALL_FEATURES_SUCCESS,
    payload: data
  };
};

// Checked
export const requestAllFeaturesFail = error => {
  return {
    type: types.REQUEST_ALL_FEATURES_FAIL,
    error
  };
};

export const selectFeatureById = id => {
  return {
    type: types.SELECT_FEATURE_BY_ID,
    id
  };
};

export const selectFeatureBookingById = id => {
  return {
    type: types.SELECT_FEATURE_BOOKING_BY_ID,
    id
  };
};

export const resetSelectedFeature = () => {
  return {
    type: types.RESET_SELECTED_FEATURE
  };
};

export const resetSelectedFeatureBooking = () => {
  return {
    type: types.RESET_FEATURE_BOOKING
  };
};

export const selectFeature = payload => {
  return {
    type: types.SELECT_FEATURE,
    payload
  };
};
